var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surround-box',[_c('div',{staticClass:"content-box"},_vm._l((_vm.data),function(item){return _c('div',{key:item.name,class:[
        'item',
        _vm.filter && _vm.filter.has(item.siteType) ? 'selected-type' : '',
      ],on:{"click":function($event){return _vm.filterChange(item.siteType)}}},[_c('img',{attrs:{"src":`/imgs/map/sitetype${item.siteType}.png`}}),_c('span',[_vm._v(" "+_vm._s(item.name)+"（"+_vm._s(item.num)+"） ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }